/**
 * bu tab 类型
 * @export
 * @enum {number}
 */
export enum EnumBuTabType {
  /** @name 中小企业 */
  SMB = 0,
  /** @name 政企（大客户） */
  RELOrISG = 2,
  /** @name 个人及家庭 */
  CON = 1,
}

/**
 * bu tab 别名
 * @export
 * @enum {string}
 */
export enum EnumBuTabAlias {
  /** @name 中小企业 */
  SMB = '中小企业',
  /** @name 政企（大客户） */
  RELOrISG = '政企',
  /** @name 个人及家庭 */
  CON = '个人及家庭',
}
